// constants.ts

import { SchemaType } from '@/store/forms/Asset-Editor/SchemaTypeOptions';

const constants = {
  defaultClipColor: '#00ff08',
  dateTimeFormat: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  dummy: {
    userIdAdmin: '7dde40c4-1c27-4b3f-a915-7fda95c78da0',
    userIdAdminName: 'James Austin',
    userIdSE: '3d65bb2e-3780-4313-8a10-83d50426478d',
    userIdSEName: 'Streaming Engine User',
    ouIdFox: '7f473dbd-fca7-430c-ae41-1be32ade7009',
    ouIdFoxName: 'Fox',
    ouIdRoot: 'd37ef207-3871-495c-ad87-550d87313767',
    ouIdRootName: 'BitCentral',
    timeZone: 'America/Los_Angeles', // "PDT"
  },
  pagination: {
    page: 0,
    size: 10,
  },
};

const REPEAT_List = [
  {
    id: 'never',
    name: 'Never',
    enumValue: -1,
  },
  {
    id: 'daily',
    name: 'Daily',
    enumValue: 3,
  },
  {
    id: 'weekly',
    name: 'Weekly',
    enumValue: 2,
  },
  {
    id: 'monthly',
    name: 'Monthly',
    enumValue: 1,
  },
  {
    id: 'yearly',
    name: 'Yearly',
    enumValue: 0,
  },
];

export const CATEGORY_NAME_REGEX = /^[a-zA-Z0-9 -]+$/;
export const INVALID_CATEGORY_NAME_WARNING_MESSAGE = 'WARNING: Category Names cannot contain special characters.';

const BACKSTOP_WARNING_MESSAGE =
  'WARNING: Backstop channel variants do NOT match selected variant codes. \
  Please check the selected backstop channel before saving.';

const SchemaTypeDictionary = {
  [SchemaType.Image]: ['.jpeg', '.jpg', '.png', '.gif'],
  [SchemaType.Video]: ['.mp4', '.mov', '.mpeg4', '.mxf', '.wmv', '.mpeg', '.mpg', '.mkv'],
  [SchemaType.Graphics]: ['.mov'],
};

const MAX_FILE_SIZE_20GB = { name: '20 GB limit', fileSize: 20 * 1024 * 1024 * 1024 };

export { BACKSTOP_WARNING_MESSAGE, constants, MAX_FILE_SIZE_20GB, REPEAT_List, SchemaTypeDictionary };
